import { TYPE, useEnergyRpt, useEnergyRptExport } from '@services/report'
import Flex from '@shared/Flex'
import { Button, Input } from '@shared/Form'
import useSearch from '@shared/innmaxLib/hooks/useSearch'
import Layout from '@shared/Layout'
import Table from '@shared/Table'
import { downloadFile } from '@shared/utils/webHelper'
import { Form } from 'antd'
import { ColumnsType } from 'antd/es/table'
import moment from 'moment'
import { isNil } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'src/components/Form'
import OptionsSelect from 'src/components/OptionsSelect'

const initialReportType = {
  reportType: TYPE.YEAR,
  conditionDate: new Date().getFullYear(),
  startAt: moment().startOf('year').valueOf(),
  endAt: moment().endOf('year').valueOf(),
}

function EnergyV2() {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const [currentType, setCurrentType] = React.useState(TYPE.YEAR)
  const [isSearch, setIsSearch] = React.useState(false)

  const { query, handleSearch, handleTableChange } = useSearch({
    form,
    initial: initialReportType,
    dateRangeField: ['startAt', 'endAt'],
  })

  const handleReportType = (val: any) => {
    setCurrentType(val?.reportType)
    return val
  }

  console.log('query', query)

  const { loading, dataSource, cols } = useEnergyRpt(query)

  const [exporting, handleExport] = useEnergyRptExport(query, {
    onSuccess: (blob: any) => {
      downloadFile({
        blob,
        filename: 'EnergyReport',
      })
    },
  })

  const columns: ColumnsType<any> = [
    {
      title: '充電樁編號',
      dataIndex: 'chargePointId',
      align: 'center',
      width: 150,
    },
    {
      title: '槍號',
      dataIndex: 'connectorId',
      align: 'center',
      width: 150,
    },
    {
      title: '電錶編號',
      dataIndex: 'electricMeterId',
      align: 'center',
      width: 150,
    },
    {
      title: '合計',
      dataIndex: 'total',
      align: 'center',
      render: (_, record) => {
        return <span>{record.total} kWh</span>
      },
    },
    ...cols,
  ]

  React.useEffect(() => {
    if (!isNil(query) && !isNil(query.reportType)) {
      setIsSearch(true)
    }
  }, [query])

  return (
    <>
      <Layout>
        <Form layout="inline" form={form}>
          <FormItem label={'關鍵字'} name="input" className="w-[280px]">
            <Input placeholder="充電樁或充電槍編號" />
          </FormItem>
          <FormItem label={'航廈/站點'} name="sessionId" className="w-[280px]">
            <OptionsSelect.CityAreaSelect
              className="w-130"
              supportAll
              allowAllArea
              allowClear
            />
          </FormItem>

          <FormItem
            label={`${t('report:report type')} / ${t('report:time')}`}
            name="reportTime"
            initialValue={initialReportType}
            className={currentType === TYPE.DAY ? 'w-[380px]' : 'w-[250px]'}
            getValueFromEvent={handleReportType}>
            <OptionsSelect.ReportRangeTimeSelect
              maxRange={{
                range: 2,
                unit: 'week',
              }}
            />
          </FormItem>

          <FormItem.Button>
            <Button
              loading={false}
              type="primary"
              className="w-96"
              onClick={handleSearch}>
              {t('common:search')}
            </Button>
          </FormItem.Button>
          <FormItem.Button>
            <Button
              loading={exporting}
              type="primary"
              ghost
              className="w-96"
              onClick={handleExport}>
              {t('report:export')}
            </Button>
          </FormItem.Button>
        </Form>

        {/* <div className="mt-44 mb-16">
          <Flex between>
            <Table.RowCount count={dataSource.total} />
          </Flex>
        </div>
        <Table
          columns={columns}
          loading={loading}
          dataSource={dataSource}
          onChange={handleTableChange}
        /> */}

        {isSearch ? (
          <>
            <div className="mt-44 mb-16">
              <Flex between>
                <Table.RowCount count={dataSource?.content?.length || 0} />
              </Flex>
            </div>
            <div style={{ width: 'calc(100vw - 200px)' }}>
              <Table
                simpleMode
                scroll={{ x: 'max-content' }}
                columns={columns}
                loading={loading}
                dataSource={dataSource || []}
                onChange={handleTableChange}
                pagination={false}
              />
            </div>
          </>
        ) : (
          <div
            className="flex justify-center items-center text-center text-lg"
            style={{ color: '#8E8E8E', height: '50dvh', width: '50dvw' }}>
            <span>請先輸入搜尋條件範圍</span>
          </div>
        )}
      </Layout>
    </>
  )
}

export default React.memo(EnergyV2)
